const initialState = { 
  loading: false,
  payload: [],
  page: 1,
  pages: 1,
  error: null
}

function listAgentReducer(state = initialState, action) {
  switch (action.type) {
    case 'LIST_AGENT_DROPSHIP_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'LIST_AGENT_DROPSHIP_SUCCESS':
      return {
        ...state,
        loading: false,
        page: action.page,
        pages: action.pages,
        payload: action.payload
      }

    case 'LIST_AGENT_DROPSHIP_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default listAgentReducer